
import "./Css/ExamManagment.css";
import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";


const exams = [
    {
        id: 1,
        book: "02",
        price: "₹१००",
        date: "१०-११-२०२५",
        amount: "₹५०",
        cumission: "₹1०",
        status: "जमा",

    },
    {
        id: 2,
        book: "02",
        price: "₹५००",
        date: "०६-११-२०२५",
        amount: "₹१०",
        cumission: "₹1०",
        status: "जमा",
    },
    {
        id: 3,
        book: "05",
        price: "₹४५०",
        date: "०८-११-२०२५",
        amount: "₹४०",
        cumission: "₹1०",
        status: "बाकी",

    },
    {
        id: 4,
        book: "01",
        price: "₹२००",
        date: "२०-१०-२०२५",
        amount: "₹६०",
        cumission: "₹1०",
        status: "जमा",

    },
    {
        id: 5,
        book: "10",
        price: "₹६००",
        date: "२५-११-२०२५",
        amount: "₹७०",
        status: "बाकी",
        cumission: "₹1०",

    },
    {
        id: 6,
        book: "15",
        price: "₹८००",
        date: "२५-११-२०२५",
        amount: "₹२४०",
        cumission: "₹1०",
        status: "जमा",

    },
];

const CumissionDetails = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [examList, setExamList] = useState(exams);


    const filteredData = examList.filter((exam) =>
        exam.book.toLowerCase().includes(searchQuery.toLowerCase()) ||
        exam.id.toString().includes(searchQuery)
    );
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    return (
        <div className="exam-page">
            <div className="page-header">
                <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
                    पुस्तक व्यवस्थापन  &gt;&gt; <span>कमिशन आढावा</span>
                </h3>

                <div className="edit-btnn">
                    <button className="btn-outline">
                        एक्स्पोर्ट करा
                    </button>
                    <button className="primary-btn" onClick={() => navigate('/dashboard/cumissionanalysis')} >
                     कमिशन विश्लेषण  
                    </button>
                </div>
            </div>
            <div className="filters">
                <div className="search-wrapper-exam">
                    <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
                        <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
                    <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                </div>
                <select>
                    <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12.0011 18.6947L6.00113 15.4332V10.587L3.07812 9.0025L12.0011 4.15625L20.9241 9.0025V15.3872H19.9241V9.564L18.0011 10.587V15.4332L12.0011 18.6947ZM12.0011 12.7025L18.8319 9.0025L12.0011 5.3025L5.17038 9.0025L12.0011 12.7025ZM12.0011 17.5545L17.0011 14.8545V11.137L12.0011 13.845L7.00113 11.137V14.8545L12.0011 17.5545Z" fill="#616161" />
                    </svg>महिना निवडा </option>
                    <option>जानेवरी</option>
                    <option>फेब्रुवारी</option>
                    <option>मार्च</option>
                </select>
            </div>
            <div className="state">
                <div className="stats purple">
                    <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path d="M22.7658 28.8142H24.9071L24.9392 28.6892L18.4808 21.7442L18.5225 21.625H18.9392C20.5672 21.625 21.8957 21.2094 22.9246 20.3783C23.9535 19.5469 24.5363 18.4347 24.6729 17.0417H26.2758V15.6925H24.6271C24.5465 15.1047 24.3647 14.57 24.0817 14.0883C23.7986 13.6064 23.4401 13.1849 23.0063 12.8238H26.2758V11.4742H13.7242V12.92H19.0383C20.1239 12.92 21.0187 13.1646 21.7229 13.6538C22.4268 14.1432 22.8621 14.8228 23.0288 15.6925H13.7242V17.0417H23.0704C22.9465 18.0033 22.5256 18.7603 21.8075 19.3125C21.0897 19.8647 20.1571 20.1408 19.0096 20.1408H16.2533V21.75L22.7658 28.8142ZM20.0054 35C17.9313 35 15.9811 34.6064 14.155 33.8192C12.3292 33.0319 10.7408 31.9636 9.39 30.6142C8.03917 29.2647 6.96986 27.6778 6.18208 25.8533C5.39403 24.0292 5 22.0799 5 20.0054C5 17.9313 5.39361 15.9811 6.18083 14.155C6.96806 12.3292 8.03639 10.7408 9.38583 9.39C10.7353 8.03917 12.3222 6.96986 14.1467 6.18208C15.9708 5.39403 17.9201 5 19.9946 5C22.0688 5 24.0189 5.39361 25.845 6.18083C27.6708 6.96806 29.2592 8.03639 30.61 9.38583C31.9608 10.7353 33.0301 12.3222 33.8179 14.1467C34.606 15.9708 35 17.9201 35 19.9946C35 22.0688 34.6064 24.0189 33.8192 25.845C33.0319 27.6708 31.9636 29.2592 30.6142 30.61C29.2647 31.9608 27.6778 33.0301 25.8533 33.8179C24.0292 34.606 22.0799 35 20.0054 35Z" fill="#8D62EE" />
                    </svg></div>
                    <div>
                        <h4>एकूण कमिशन</h4>
                        <p>₹१२,५००</p>
                    </div>
                </div>
                <div className="stats green">
                    <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path d="M28.9742 35.0006C27.1175 35.0006 25.5422 34.3537 24.2483 33.0598C22.9544 31.7662 22.3075 30.1909 22.3075 28.334C22.3075 26.477 22.9544 24.9017 24.2483 23.6081C25.5422 22.3142 27.1175 21.6673 28.9742 21.6673C30.8311 21.6673 32.4065 22.3142 33.7004 23.6081C34.994 24.9017 35.6408 26.477 35.6408 28.334C35.6408 30.1909 34.994 31.7662 33.7004 33.0598C32.4065 34.3537 30.8311 35.0006 28.9742 35.0006ZM31.7342 32.004L32.6442 31.0935L29.6154 28.0648V23.5265H28.3333V28.6031L31.7342 32.004ZM9.35916 33.334C8.61333 33.334 7.97805 33.0717 7.45333 32.5473C6.92889 32.0226 6.66666 31.3873 6.66666 30.6415V9.35979C6.66666 8.61396 6.92889 7.97868 7.45333 7.45396C7.97805 6.92951 8.61333 6.66729 9.35916 6.66729H17.0867C17.2425 6.01563 17.5886 5.46813 18.125 5.02479C18.6614 4.58118 19.2864 4.35938 20 4.35938C20.7264 4.35938 21.3562 4.58118 21.8896 5.02479C22.4226 5.46813 22.7671 6.01563 22.9229 6.66729H30.6408C31.3867 6.66729 32.0219 6.92951 32.5467 7.45396C33.0711 7.97868 33.3333 8.61396 33.3333 9.35979V19.3915C33.0469 19.2442 32.7756 19.1151 32.5192 19.004C32.2628 18.8928 31.9786 18.7934 31.6667 18.7056V9.35979C31.6667 9.10313 31.5599 8.86799 31.3462 8.65438C31.1326 8.44076 30.8975 8.33396 30.6408 8.33396H26.6667V12.0519H13.3333V8.33396H9.35916C9.1025 8.33396 8.86736 8.44076 8.65375 8.65438C8.44014 8.86799 8.33333 9.10313 8.33333 9.35979V30.6415C8.33333 30.9406 8.42944 31.1865 8.62166 31.379C8.81416 31.5712 9.06 31.6673 9.35916 31.6673H19.5704C19.6582 31.9792 19.7629 32.2688 19.8846 32.536C20.0065 32.803 20.1625 33.069 20.3525 33.334H9.35916ZM20 8.71854C20.3867 8.71854 20.7078 8.5909 20.9633 8.33562C21.2186 8.08035 21.3462 7.75924 21.3462 7.37229C21.3462 6.98563 21.2186 6.66465 20.9633 6.40938C20.7078 6.1541 20.3867 6.02646 20 6.02646C19.6133 6.02646 19.2922 6.1541 19.0367 6.40938C18.7814 6.66465 18.6537 6.98563 18.6537 7.37229C18.6537 7.75924 18.7814 8.08035 19.0367 8.33562C19.2922 8.5909 19.6133 8.71854 20 8.71854Z" fill="#4C9E9E" />
                    </svg></div>
                    <div>
                        <h4>प्रलंबित पेआउट</h4>
                        <p>₹३,०००</p>
                    </div>
                </div>
                <div className="stats blue">
                    <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M14.1408 26.0258H15.7758V24.0704C16.9722 23.9701 18.1185 23.5407 19.2146 22.7821C20.311 22.0235 20.8592 20.8461 20.8592 19.25C20.8592 18.0833 20.5044 17.0886 19.795 16.2658C19.0856 15.4433 17.7308 14.671 15.7308 13.9487C13.8931 13.3076 12.7189 12.7574 12.2083 12.2979C11.6978 11.8388 11.4425 11.1839 11.4425 10.3333C11.4425 9.48278 11.7742 8.77445 12.4375 8.20833C13.1008 7.64222 13.9828 7.35917 15.0833 7.35917C15.9294 7.35917 16.6346 7.55306 17.1988 7.94083C17.7629 8.32861 18.2201 8.82056 18.5704 9.41667L20.0192 8.84625C19.6281 8.04486 19.0549 7.37389 18.2996 6.83333C17.5443 6.29278 16.7308 5.99153 15.8592 5.92958V3.97417H14.2242V5.92958C12.7714 6.17097 11.6721 6.71264 10.9263 7.55458C10.1804 8.39653 9.8075 9.32278 9.8075 10.3333C9.8075 11.5319 10.1842 12.4914 10.9375 13.2117C11.6908 13.9317 12.9617 14.6154 14.75 15.2629C16.5428 15.9232 17.7474 16.5193 18.3638 17.0513C18.9801 17.5832 19.2883 18.3161 19.2883 19.25C19.2883 20.4231 18.8606 21.2676 18.005 21.7838C17.1492 22.2996 16.2308 22.5575 15.25 22.5575C14.2906 22.5575 13.4246 22.2782 12.6521 21.7196C11.8799 21.1607 11.2629 20.3653 10.8013 19.3333L9.33333 19.9679C9.80778 21.109 10.444 21.9985 11.2421 22.6363C12.0401 23.274 13.0064 23.7243 14.1408 23.9871V26.0258ZM15 30C12.9294 30 10.9818 29.6053 9.15708 28.8158C7.33236 28.0261 5.74472 26.9561 4.39417 25.6058C3.04389 24.2553 1.97389 22.6676 1.18417 20.8429C0.394722 19.0182 0 17.0706 0 15C0 12.9294 0.394722 10.9818 1.18417 9.15708C1.97389 7.33236 3.04389 5.74472 4.39417 4.39417C5.74472 3.04389 7.33236 1.97389 9.15708 1.18417C10.9818 0.394722 12.9294 0 15 0C17.0706 0 19.0182 0.394722 20.8429 1.18417C22.6676 1.97389 24.2553 3.04389 25.6058 4.39417C26.9561 5.74472 28.0261 7.33236 28.8158 9.15708C29.6053 10.9818 30 12.9294 30 15C30 17.0706 29.6053 19.0182 28.8158 20.8429C28.0261 22.6676 26.9561 24.2553 25.6058 25.6058C24.2553 26.9561 22.6676 28.0261 20.8429 28.8158C19.0182 29.6053 17.0706 30 15 30Z" fill="#4BA3E0" />
                    </svg></div>
                    <div>
                        <h4>पूर्ण पेआउट</h4>
                        <p>₹९,५००</p>
                    </div>
                </div>
            </div>

            <h2>कमिशन तपशील</h2>
            <div className="table-card">
                <table>
                    <thead>
                        <tr>
                            <th>क्र.</th>
                            <th>जमा तारीख </th>
                            <th>विक्री केलेली पुस्तके</th>
                            <th>एकूण विक्री रक्कम</th>
                            <th>कमिशन (%)</th>
                            <th>मिळालेलं कमिशन</th>
                            <th>पेआउट स्थिती</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.map((exam, index) => (
                            <tr
                                key={exam.id}
                            >
                                <td>{index + 1}</td>
                                <td>{exam.date}</td>
                                <td>{exam.book}</td>
                                <td>{exam.price}</td>
                                <td>{exam.cumission}</td>
                                <td>{exam.amount}</td>
                               <td className={`status ${exam.status === "जमा" ? "status-paid" : "status-pending"}`}>
  {exam.status}
</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='que-pagination-container'>
                <div className="que-pagination-controlss">
                    <button
                        className="que-pagination-btn"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>

                    {[...Array(totalPages).keys()]
                        .map((_, i) => i + 1)
                        .slice(
                            Math.max(currentPage - 2, 0),
                            Math.min(currentPage + 1, totalPages)
                        )
                        .map((page) => (
                            <button
                                key={page}
                                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                                    }`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                        ))}

                    <button
                        className="que-pagination-btn"
                        onClick={() =>
                            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                        }
                        disabled={currentPage === totalPages}
                    >
                        &gt;
                    </button>
                    {/* Rows per page and range info */}
                    <div className="que-pagination-controls">
                        <span className="que-rows-label">Rows per page:</span>
                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                            className="que-rows-dropdown"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CumissionDetails;
